/**
 * Created by Karol Kluska on 10.11.17.
 */

angular
  .module('app')
  .component('paymentRedirect', {
    controller: PaymentRedirect
  });

/** @ngInject */
// eslint-disable-next-line
function PaymentRedirect($rootScope, $translate) {
  var $this = this;
  $this.$rootScope = $rootScope;
  $this.$translate = $translate;
}

PaymentRedirect.prototype = {
  $onInit: function () {
    this.$rootScope.$emit('startLoading', {
      title: this.$translate.instant('loader.PLEASE_WAIT'),
      description: 'Trwa przekierowanie'
    });
  }
};
